var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgThisWay = function SvgThisWay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 70 70"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipPath: "url(#this-way_svg__a)",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#CCC",
    d: "m11.314 34.627 16.97-16.97L22.627 12 5.657 28.97 0 34.628l5.657 5.657 16.97 16.97 5.657-5.656-16.97-16.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#999",
    d: "m31.314 34.627 16.97-16.97L42.627 12l-16.97 16.97L20 34.628l5.657 5.657 16.97 16.97 5.657-5.656-16.97-16.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#666",
    d: "m51.314 34.627 16.97-16.97L62.627 12l-16.97 16.97L40 34.628l5.657 5.657 16.97 16.97 5.657-5.656-16.97-16.97Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "this-way_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h70v70H0z"
  })))));
};
export default SvgThisWay;